import React, { memo, useEffect, useState } from "react";
import PropTypes from "prop-types";

import { BETTO_ALERT_ILLUSTRATION_LOADERS } from "./bettoAlertIllustrations";
import { BettoAlertIllustration } from "./BettoAlertModal.styles";

export const BettoAlertIllustrationImage = memo(({ illustrationKey }) => {
	const [src, setSrc] = useState(null);

	useEffect(() => {
		let isActive = true;
		const loadIllustration = BETTO_ALERT_ILLUSTRATION_LOADERS[illustrationKey];

		setSrc(null);

		if (!loadIllustration) {
			return undefined;
		}

		loadIllustration().then((module) => {
			if (isActive) {
				setSrc(module.default);
			}
		});

		return () => {
			isActive = false;
		};
	}, [illustrationKey]);

	return (
		<BettoAlertIllustration aria-hidden="true">
			{src ? (
				<img
					src={src}
					alt=""
					decoding="async"
				/>
			) : null}
		</BettoAlertIllustration>
	);
});

BettoAlertIllustrationImage.displayName = "BettoAlertIllustrationImage";

BettoAlertIllustrationImage.propTypes = {
	illustrationKey: PropTypes.string.isRequired,
};
